import CONFIG from "@APP/config";
import { BusinessLevelContactStatus } from "@APP/types";

import { DEFAULT_USER } from "./../constants";
import request from "../request";

const TEMP_API_BASE = "/api";

export const login = async () => {
  const { data } = await request<{ token: string }>(
    {
      method: "POST",
      url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/user-mgmt/public/login`,
      data: DEFAULT_USER,
    },
    {
      auth: false,
    },
  );
  return data.token;
};

export const verifyBusinessContactEmail = async (email: string, orgId: string) => {
  const res = await request<BusinessLevelContactStatus>(
    {
      method: "GET",
      url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/user-mgmt/public/organisations/${orgId}/contact/verify/${email}`,
    },
    {
      auth: false,
    },
  );
  return res.data;
};

// This function fetches the organization logo from the server
// using the provided organization ID.
export const getOrganizationLogo = async (orgId: string) => {
  if (!orgId) {
    throw new Error("Organization ID is required to fetch the logo.");
  }

  const url = `${TEMP_API_BASE}/user-mgmt/logo/${orgId}`;

  const res = await request<ArrayBuffer>(
    {
      method: "GET",
      url,
      responseType: "arraybuffer",
    },
    {
      auth: false,
    },
  );

  const base64 = arrayBufferToBase64(res.data);

  if (!isValidPngDataUrl(base64)) {
    throw new Error("Invalid PNG data URL");
  }

  return base64;
};

// This function checks if the provided URL is a valid PNG data URL.
// It uses a regular expression to validate the format of the URL.
function isValidPngDataUrl(url: string | null): boolean {
  return typeof url === "string" && /^data:image\/png;base64,[A-Za-z0-9+/=]+$/.test(url);
}

// Helper function to convert ArrayBuffer to Base64
// This function converts an ArrayBuffer to a Base64 string
// and prepends the appropriate data URL prefix for PNG images.
function arrayBufferToBase64(buffer: ArrayBuffer): string {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;

  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return `data:image/png;base64,${btoa(binary)}`;
}
